import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { MatLegacySlideToggleChange as MatSlideToggleChange } from '@angular/material/legacy-slide-toggle';
import { Router } from '@angular/router';
import { AddProductModalComponent } from '@app/modules/product-catalog/components/add-product/add-product-modal.component';
import { NotificationType } from '@app/shared/interfaces';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';
import { ProductCatalogService, ProductCategory, ProductItem } from '../../services/product-catalog.service';

@Component({
  standalone: false,
  selector: 'sbnb-product-catalog-products',
  templateUrl: './product-catalog-products.component.html',
  styleUrls: ['./product-catalog-products.component.scss', './product-catalog-products.component.mobile.scss'],
})
export class ProductCatalogProductsComponent implements OnInit {
  productCategories: ProductCategory[];
  loading = true;
  hasSmartUpsell = true;

  constructor(
    private productCatalogService: ProductCatalogService,
    private toast: ToastNotificationsService,
    private router: Router,
    private dialog: MatDialog
  ) { }

  ngOnInit() {
    this.loadProducts();
    this.checkSmartCodeStatus();
  }

  loadProducts() {
    this.loading = true;
    this.productCatalogService.getProductCategories().subscribe(
      (res) => {
        this.productCategories = res.data;
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        console.error('Error loading products:', error);
        this.toast.open('Error loading products', 'Dismiss', NotificationType.Error);
      }
    );
  }

  getStartedClicked() {
    this.productCatalogService.setupDefaultProducts().subscribe(() => {
      this.loadProducts();
    });
  }

  addNewClicked() {
    const dialogRef = this.dialog.open(AddProductModalComponent, {
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      maxHeight: '100vh',
      panelClass: 'full-screen-modal',
    });

    dialogRef.afterClosed().subscribe((result: ProductItem | any) => {
      if (result.id) {
        this.router.navigate([`/gx/upsells/${result.id}`]);
      }
    });
  }

  activateOrDeactivateProduct(product: ProductItem, event: MatSlideToggleChange) {
    const newStatus = event.checked;
    this.productCatalogService.activeOrDeactivateProduct(product.id, newStatus).subscribe(
      () => {
        product.active = newStatus;
      },
      (error) => {
        console.error('Error updating product status:', error);
        this.toast.open('Error updating product status', 'Dismiss', NotificationType.Error);

        // Revert the toggle if the API call fails
        event.source.checked = !newStatus;
      }
    );
  }

  checkSmartCodeStatus() {
    this.productCatalogService.getSmartUpsellRules().subscribe(
      (response) => {
        this.hasSmartUpsell = response.length > 0;
      },
      (error) => {
        console.error('Error checking smart upsell rules:', error);
      }
    );
  }

  navigateToMessagingRules() {
    // Before check-in segment
    this.router.navigate(['/gx/rules/segments/47dd6325-87dc-48e1-bebd-e68f532410ca']);
  }

  hasActiveProducts(): boolean {
    return this.productCategories?.some((category) => category.products?.some((product) => product.active)) ?? false;
  }
}
